/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetOrganizationGatewaySecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type GetOrganizationGatewayRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetOrganizationGatewaySecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetOrganizationGatewaySecurity$outboundSchema: z.ZodMiniType<
  GetOrganizationGatewaySecurity$Outbound,
  GetOrganizationGatewaySecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getOrganizationGatewaySecurityToJSON(
  getOrganizationGatewaySecurity: GetOrganizationGatewaySecurity,
): string {
  return JSON.stringify(
    GetOrganizationGatewaySecurity$outboundSchema.parse(
      getOrganizationGatewaySecurity,
    ),
  );
}

/** @internal */
export type GetOrganizationGatewayRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const GetOrganizationGatewayRequest$outboundSchema: z.ZodMiniType<
  GetOrganizationGatewayRequest$Outbound,
  GetOrganizationGatewayRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function getOrganizationGatewayRequestToJSON(
  getOrganizationGatewayRequest: GetOrganizationGatewayRequest,
): string {
  return JSON.stringify(
    GetOrganizationGatewayRequest$outboundSchema.parse(
      getOrganizationGatewayRequest,
    ),
  );
}
